var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { folderEntriesQuery } from './query';
export function useFolderEntries(folderId) {
    const _a = useQuery(folderEntriesQuery, {
        fetchPolicy: 'cache-and-network',
        variables: {
            folderId,
        },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const { folder, entries = [] } = data || {};
    const { name: folderName = '' } = folder || {};
    return Object.assign(Object.assign({}, rest), { data: { folderName, entries } });
}
